import { render, staticRenderFns } from "./InventoryDashboard.vue?vue&type=template&id=6c3756d0&scoped=true&"
import script from "./InventoryDashboard.vue?vue&type=script&lang=js&"
export * from "./InventoryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDashboard.vue?vue&type=style&index=0&id=6c3756d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3756d0",
  null
  
)

export default component.exports